import { render, staticRenderFns } from "./WelfareH5.vue?vue&type=template&id=b7ca5b8a&scoped=true&"
import script from "./WelfareH5.vue?vue&type=script&lang=js&"
export * from "./WelfareH5.vue?vue&type=script&lang=js&"
import style0 from "./WelfareH5.vue?vue&type=style&index=0&id=b7ca5b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ca5b8a",
  null
  
)

export default component.exports